<template>
  <component
    :is="componentType"
    v-if="!isEditingTranslationModel || !hideWhenTranslating"
    v-bind="$attrs"
    ref="inputComponent"
    :autofocus="computedAutofocus"
    :hint="computedHint"
    :label-color="isEditingTranslationAndFieldTranslatable ? 'amber-9' : undefined"
    :bg-color="isEditingTranslationAndFieldTranslatable ? 'amber-1' : undefined"
    :disable="computedDisable && !computedReadonly"
    :readonly="computedReadonly"
    :placeholder="computedPlaceholder"
    :rules="computedRules"
    :model-value="fieldValue"
    bottom-slots
    data-test-id="model-form-input"
    @update:model-value="handleInput"
  >
    <untranslatable-field-tooltip v-if="isEditingTranslationAndFieldNotTranslatable" />
    <action-not-permitted-tooltip v-if="isFieldValueMaskedByApi" />

    <template
      v-for="slotName in computedSlots"
      :key="slotName"
      #[slotName]="slotProps"
    >
      <slot
        v-bind="slotProps ?? {}"
        :name="slotName"
      />
    </template>
  </component>
</template>

<script>
import { IsoDate } from 'src/models/model'
import IsoDateInput from 'src/modules/admin/components/IsoDateInput'
import ModelFormFieldMixin from 'src/modules/admin/components/ModelForm/mixins/ModelFormFieldMixin'
import { defineAsyncComponent } from 'vue'

export default {
  name: 'ModelFormInput',
  components: {
    ActionNotPermittedTooltip: defineAsyncComponent(() => import('src/modules/admin/components/ModelForm/components/ActionNotPermittedTooltip')),
    UntranslatableFieldTooltip: defineAsyncComponent(() => import('src/modules/admin/components/ModelForm/components/UntranslatableFieldTooltip'))
  },
  mixins: [ModelFormFieldMixin],
  computed: {
    componentType () {
      if (this.fieldType?.Type === IsoDate || this.valueType === IsoDate || this.valueType === 'IsoDate') {
        return IsoDateInput
      } else {
        return 'q-input'
      }
    }
  }
}
</script>
